export default __webpack_public_path__ + "static/media/BookmarkSmall.8cffe891.svg";